import { useMemo } from 'react';

import { Region } from '../../graphql';
import { useCountriesAndCurrencies } from './useCountriesAndCurrencies';

/**
 * Unknown codes yield `isEmea: false`, so callers must check `loading` before acting on it —
 * otherwise an unresolved EMEA country reads as non-EMEA.
 */
export const useIsEmeaCountry = (
  countryCode: string
): Readonly<{ isEmea: boolean; loading: boolean }> => {
  const { countries, loading } = useCountriesAndCurrencies();

  const isEmea = useMemo(
    () =>
      countries.some(country => country.id === countryCode && country.region?.id === Region.Emea),
    [countries, countryCode]
  );

  return { isEmea, loading };
};
